<template>
  <tbody>
  <tr>
    <td class="first_data" :data-th="'Privátní rozsah' |translate">{{ entity.cidr_range }}</td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="isEditable"
            class="btn btn_action btn_delete"
                        :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteIpPrefix">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
export default {
  name: "IpPrefixesRow",
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  methods: {
    emitDeleteIpPrefix() {
      this.$emit('deleteEntity', [this.entity.id]);
    },
    close(){
      this.isOpen = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/GeoblockingPrivateIpRow.vue